import React, { FC, ReactNode, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import ActivityFrame from "../../../components/activity-frame/activity-frame";
import Breadcrumb from "../../../components/breadcrumb/breadcrumb";
import { useDialog } from "../../../components/dialog/DialogContext";
import EventTypeModal from "../../../components/event-type/EventTypeModal";
import Tabs, { getTabsListFromLabels } from "../../../components/tabs/tabs";
import { toast } from "react-toastify";
import EventsTab from "../../../containers/events-tab";
import { useLocale } from "../../../contexts/localeContext";
import { TranslationKeys } from "../../../contexts/TranslationKeys";
import { useTabCount } from "../../../hooks/useCategoryTab";
import { Category } from "../../../models/Category";
import { EventType } from "../../../models/EventType";
import { storeEventType } from "../../../services/eventTypeService";
import { getErrorMessage } from "../../../services/utilities/ServiceError";

const Events: FC = () => {
    const [selected, setSelected] = useState(0);
    const [busy, setBusy] = useState(false)
    const history = useHistory();
    const { translate } = useLocale();
    const [categories, setCategories] = useState<Category[]>([
        {
            displayName: translate.byKey(TranslationKeys.events),
            heading: translate.byKey(TranslationKeys.events),
            value: "",
            id: 0,
            count: 1,
        },
    ]);
    const [tabContent, setTabContent] = useState<ReactNode[]>([]);
    const [isOpen, setIsOpen] = useState(false);
    const dialog = useDialog();
    const initialValues: EventType = {
        etAlarm: '',
        id: 0,
        name: '',
        nameOriginal: ''
    };
    const [eventTypes, setEventTypes] = useState<EventType>(initialValues);
    const { updateTabCount } = useTabCount({
        tableName: "EventType",
        categories,
        setCategories
    });

    useEffect(() => {
        if (categories.length > 0) {
            const newTabContent = [
                <EventsTab
                    setIsOpen={setIsOpen}
                    setEventType={setEventTypes}
                    onFilterChange={onFilterChange} />

            ];
            setTabContent(newTabContent);
        }
    }, [categories]);

    const editEventType = (values: any) => {
        setBusy(true);
        const record = {
            ...values,
            etPriorityLevel: values.etAlarm == "0" ? "0" : values.etPriorityLevel, // Revert the priority level to standard if alarm is off
        }
        
        storeEventType(record).then(() => {
            toast.success(translate.byKey(TranslationKeys.success));
            onModalClose();
        }).catch((error) => {
            dialog.pushError({
                title: translate.byKey(TranslationKeys.error),
                message: getErrorMessage(error),
            });
        }).finally(() => {
            setBusy(false);
        });
    }

    const onModalClose = () => {
        setEventTypes(initialValues);
        setIsOpen(false);
    }

    const onFilterChange = (_: any) => {
        updateTabCount([]);
    }

    return <ActivityFrame
        busy={busy}
        className="flex flex-grow overflow-y-hidden">
        <div id="container-tabs" className="pt-4 pl-4 pb-4 flex flex-col flex-grow ">
            <Breadcrumb
                path={[
                    {
                        value: "/access-control/configuration",
                        displayName: translate.byKey(TranslationKeys.configuration),
                        disableClick: true
                    },
                    {
                        value: "/access-control/configuration/events",
                        displayName: translate.byKey(TranslationKeys.events),
                    },
                ]}
                onClick={(item) => history.push(item.value)} />
            <Tabs
                className="overflow-y-hidden"
                tabs={getTabsListFromLabels(categories)}
                onSelect={(i) => setSelected(i)}
                selected={selected}
                onAdd={() => { }}
                add={false}
                tabStyle={{}}>
                {tabContent[selected]}
            </Tabs>
        </div>
        <EventTypeModal isOpen={isOpen} onClose={() => setIsOpen(false)} currentItem={eventTypes} editEventType={editEventType} />
    </ActivityFrame>
}

export default Events;